import React from 'react'
import { Modal } from "react-bootstrap";
import { BaseUrl } from "../helper/BaseUrl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Icons from '../myIcon/Icons';
import { useState } from "react";

export default function EnquiryPopup({ show, setShow }) {

    const navigate = useNavigate();
      const [loading, setLoading] = useState(false);
      const currentUrl = typeof window !== "undefined" ? window.location.href : "";
      const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";
    
      const [errors, setErrors] = useState({
        name: "",
        phone: "",
        email: "",
        message: "",
      });
    
      const [formData, setFormData] = useState({
        form_type: "contact_form",
        name: "",
        email: "",
        phone: "",
        message: "",
        source_url: sourceUrl,
        current_url: currentUrl,
      })
    
      const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
      const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;
        if (name === "phone") {
          updatedValue = value.replace(/\D/g, "");
        }
        if (name === "name") {
          updatedValue = value.replace(/[^a-zA-Z\s]/g, "");
        }
        setFormData((prev) => ({
          ...prev,
          [name]: updatedValue,
          source_url: sourceUrl,
          current_url: currentUrl,
        }));
        setErrors((prev) => ({
          ...prev,
          [name]: "",
          form: "",
        }));
      };
    
    
      const validate = () => {
        let newErrors = {};
    
        if (!formData.name.trim()) {
          newErrors.name = "Name is required";
        }
    
        if (!formData.phone) {
          newErrors.phone = "Mobile number is required";
        } else if (formData.phone.length !== 10) {
          newErrors.phone = "Mobile number must be 10 digits";
        }
    
        if (!formData.email) {
          newErrors.email = "Email is required";
        } else if (!emailRegex.test(formData.email)) {
          newErrors.email = "Enter valid email";
        }
    
        if (!formData.message.trim()) {
          newErrors.message = "Message is required";
        }
    
        setErrors((prev) => ({
          ...prev,
          ...newErrors,
        }));
    
        return Object.keys(newErrors).length === 0;
      };
    
    
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        try {
          setLoading(true);
          const response = await fetch(`${BaseUrl}/api/contact/store`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });
          const result = await response.json();
          if (result.error === false) {
            // toast.success(result.message || "Form submitted successfully");
    
            setTimeout(() => {
              navigate("/thankyou");
              setShow();
              setFormData({ name: "", phone: "", email: "", message: "", });
            }, 1000);
          } else {
            setErrors((prev) => ({
              ...prev,
              form: result.message || "Submission failed",
            }));
          }
        } catch (error) {
          console.error("Error:", error);
    
          setErrors((prev) => ({
            ...prev,
            form: "Something went wrong while submitting the form.",
          }));
        } finally {
          setLoading(false);
        }
      };
    
    
    return (
        <>
        <Modal className="query-popup modal-lg" show={show} onHide={() => setShow(false)} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
                <button className="popup-close" onClick={() => setShow(false)}> <Icons name="cross" /> </button>
                <div className="row m-0">
                    <div className="col-lg-7 col-md-7 no-padd">
                        <div className="query-formbox">
                            <h4 className="heading">Let’s Plan Your Perfect Stay at De Coracao</h4>
                            
                            <form onSubmit={handleSubmit}>
                                <div className="form-field">
                                    <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Full Name*" className="form-control"  />
                                    {errors.name && <p className="error-message">{errors.name}</p>}
                                </div>

                                <div className="form-field">
                                    <input name="phone" type="tel" value={formData.phone} onChange={handleChange} minLength={10} maxLength={10}  placeholder="Mobile Number*" className="form-control" />
                                    {errors.phone && <p className="error-message">{errors.phone}</p>}
                                </div>

                                <div className="form-field">
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address*" className="form-control"  />
                                    {errors.email && <p className="error-message">{errors.email}</p>}
                                </div>

                                <div className="form-field">
                                    <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your Message*" className="form-control"  />
                                    {errors.message && <p className="error-message">{errors.message}</p>}
                                </div>

                                <button style={{ opacity: loading ? "0.3" : "1" }} disabled={loading} type="submit" className="default-btn color-btn"> {loading ? "Submitting..." : ""}
                                    Send Message
                                </button>
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-5 no-padd">
                        <div className="querypop-image">
                            <img src="/image/query-image.webp" alt="query" className="img-responsive" />
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
        </>
    )
}
